import PolarisInboxes from 'dashboard/api/polaris/inboxes';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'PolarisInbox',
  API: PolarisInboxes,
  actions: mutations => ({
    update: async ({ commit }, { inboxId, assistantId, ...data }) => {
      const response = await PolarisInboxes.update({
        inboxId,
        assistantId,
        ...data,
      });
      commit(mutations.EDIT, response.data);
      return response.data;
    },
    delete: async function remove({ commit }, { inboxId, assistantId }) {
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await PolarisInboxes.delete({ inboxId, assistantId });
        commit(mutations.DELETE, inboxId);
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return inboxId;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return throwErrorMessage(error);
      }
    },
  }),
});
